import { defineSlotRecipe } from "@chakra-ui/react";
import { tableAnatomy } from "@chakra-ui/react/anatomy";

const tableRecipe = defineSlotRecipe({
  slots: tableAnatomy.keys(),
  // Restores the Chakra v2 table metrics.
  base: {
    columnHeader: {
      fontFamily: "heading",
      fontWeight: "bold",
      textTransform: "uppercase",
      letterSpacing: "wider",
      textAlign: "start",
    },
    cell: {
      textAlign: "start",
    },
  },
  variants: {
    size: {
      md: {
        root: {
          fontSize: "inherit",
          lineHeight: "inherit",
        },
        columnHeader: {
          fontSize: "xs",
          lineHeight: "1rem",
          px: "6",
          py: "3",
        },
        cell: {
          lineHeight: "1.25rem",
          px: "6",
          py: "4",
        },
      },
    },
    variant: {
      striped: {
        root: {
          border: "1px solid",
          borderColor: "gray.50",
          bg: "brand.white",
          color: "brand.black",
        },
      },
      stripedWithTrAction: {
        root: {
          border: "1px solid",
          borderColor: "gray.50",
          bg: "brand.white",
          color: "brand.tableBodyText",
          fontSize: "14px",
        },
        header: {
          zIndex: 2,
        },
        columnHeader: {
          color: "brand.tableHeaderText",
          letterSpacing: "1px",
        },
        row: {
          color: "brand.tableBodyText",
          cursor: "pointer",
          fontSize: "14px",
          "&:nth-of-type(odd) td": {
            bg: "gray.100",
          },
          _hover: {
            "& td": {
              backgroundColor: "gray.200",
            },
          },
        },
      },
    },
  },
});

export default tableRecipe;
